import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProjectAccessContext } from '../types/api';

interface ProjectAccessBadgeProps {
  accessContext?: ProjectAccessContext;
}

const ProjectAccessBadge: React.FC<ProjectAccessBadgeProps> = ({ accessContext }) => {
  const { t } = (useTranslation as any)('projects');

  if (!accessContext || !accessContext.has_access) {
    return null;
  }

  const getBadgeConfig = () => {
    switch (accessContext.access_type) {
      case 'member':
        return {
          label: accessContext.role_in_project === 'admin'
            ? t('accessBadge.adminProject')
            : t('accessBadge.member'),
          className: 'bg-accent-100 text-accent-800'
        };
      case 'org_owner':
        return {
          label: t('accessBadge.orgOwner'),
          className: 'bg-purple-100 text-purple-800'
        };
      case 'both':
        return {
          label: t('accessBadge.adminAndOwner'),
          className: 'bg-gradient-to-r from-accent-100 to-purple-100 text-accent-900'
        };
      case 'org_admin':
        return {
          label: t('accessBadge.orgAdmin'),
          className: 'bg-purple-100 text-purple-800'
        };
      case 'group':
        // Acces herite d'un ou plusieurs groupes seulement (pas d'adhesion directe)
        return {
          label: accessContext.groups && accessContext.groups.length
            ? t('accessBadge.viaGroup', { name: accessContext.groups.join(', ') })
            : t('accessBadge.group'),
          className: 'bg-blue-100 text-blue-800'
        };
      default:
        return null;
    }
  };

  const config = getBadgeConfig();
  if (!config) return null;

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.className}`}>
      {config.label}
    </span>
  );
};

export default ProjectAccessBadge;
